var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(configuration, viewType) {
        var _this = _super.call(this) || this;
        _this.enable = function () {
            _this.self.removeAttribute('disabled');
            _this.self.style.cursor = 'text';
        };
        _this.disable = function () {
            _this.self.setAttribute('disabled', 'true');
            _this.self.style.cursor = 'wait';
        };
        _this.setSmallSizeWindow = function () {
            _this.self.style.width = '100%';
        };
        _this.setFullSizeWindow = function () {
            _this.self.style.width = '100%';
        };
        _this.addPlaceholderStyles = function (element, color) {
            element.insertAdjacentHTML('afterbegin', "\n            <style type=\"text/css\">\n                #js_aigo_bot_input::placeholder {\n                    color: ".concat(color, ";\n                }\n            </style>\n        "));
        };
        var input = document.createElement('input');
        input.id = 'js_aigo_bot_input';
        input.placeholder = configuration.questionInputText;
        input.style.borderRadius = '5px';
        input.style.height = '34px';
        input.style.border = 'none';
        input.style.outline = 'none';
        input.style.paddingInline = '10px';
        input.style.paddingLeft = '7px';
        input.style.color = configuration.questionInputFontColor;
        input.style.backgroundColor = configuration.questionInputBackgroundColor;
        input.style.fontFamily = 'inherit';
        input.style.boxSizing = 'border-box';
        input.style.flex = '1 1 auto';
        input.style.minWidth = '0';
        if (viewType === ViewType.MobileSmall || viewType === ViewType.MobileLarge) {
            input.style.fontSize = '16px';
        }
        _this.addPlaceholderStyles(input, configuration.questionInputFontColor);
        _this.self = input;
        if (viewType === ViewType.DesktopSmall) {
            _this.setSmallSizeWindow();
        }
        else {
            _this.setFullSizeWindow();
        }
        return _this;
    }
    Input.prototype.getValue = function () {
        return this.self.value;
    };
    Input.prototype.clearValue = function () {
        this.self.value = '';
    };
    return Input;
}(Base));
export { Input };
